<template>
  <b-row align-h="center" class="mt-3">
    <b-col md="6">
      <b-card>
        <login-modal />
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
  import {userStore} from "@/store/store";
  import {Component, Vue} from 'vue-property-decorator';
  import LoginModal from "./components/home/LoginModal";
  @Component({
    components: {LoginModal}
  })
  export default class LoginPage extends Vue {
    get userIsLoggedIn(){
      return userStore.userIsLoggedIn
    }
  }

</script>

<style scoped lang="scss">

  #background-image {
    background: black url('../assets/home-page-1.jpg') no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    height: 775px;
    opacity: 0.5;
  }

</style>
